import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchAccessPointData } from '../../../api/types';
import { AccessPointTile } from '../../AccessPointCard/AccessPointTile';
import { useTranslations } from '../../Translations/TranslationsProvider';
import { LoadMoreButton } from './LoadMoreButton';

interface AccessPointsResultsProps {
    accessPoints: SearchAccessPointData[] | null;
    currentHint: string;
    currentPage: number;
    getAccessPointsList: (arg: { hint: string; page: number }) => void;
    isLoading: boolean;
    totalResults: number;
}

export const AccessPointsResults: React.FC<AccessPointsResultsProps> = ({
    accessPoints,
    currentHint,
    currentPage,
    getAccessPointsList,
    isLoading,
    totalResults,
}) => {
    const { translations } = useTranslations();
    const navigate = useNavigate();

    const handleLoadMore = () => {
        getAccessPointsList({ hint: currentHint, page: currentPage });
    };

    const onCardClick = (code: string) => {
        navigate(`${location.pathname}?hint=${currentHint}`, { replace: true });
        navigate(`/accesspoint/${code}`);
    };

    if (accessPoints === null) return <></>;

    return accessPoints?.length > 0 ? (
        <Grid container spacing={2}>
            {accessPoints?.map((accessPoint: SearchAccessPointData) => (
                <Grid item xs={12} key={accessPoint.accessPointID}>
                    <AccessPointTile accessPoint={accessPoint} onClick={onCardClick} />
                </Grid>
            ))}
            <LoadMoreButton
                currentPage={currentPage}
                isLoading={isLoading}
                handleLoadMore={handleLoadMore}
                totalResults={totalResults}
            />
        </Grid>
    ) : (
        <Grid container direction="column" alignItems="center" justifyContent="center" spacing={0}>
            <Typography variant="h5" color="textSecondary" style={{ textAlign: 'center' }}>
                {translations.SEARCH_ACCESS_POINT_NO_DATA}
            </Typography>
        </Grid>
    );
};
